import React from "react";
import DynamicForm from "../../components/form/DynamicForm";

const BasicDetailsStep = ({
  inputs,
  registerData,
  setRegisterData,
}) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setRegisterData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div>
      <DynamicForm
        inputs={inputs}
        values={registerData}
        onChange={handleChange}
      />
    </div>
  );
};

export default BasicDetailsStep;
